import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ButtonGroup = styled.div`
  button {
    &:first-child {
      border-radius: 4px 0 0 4px;
      border-right: none;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }
`;

const CustomButton = styled.button<{ selected: boolean }>`
  background-color: ${({ theme, selected }) =>
    selected ? theme.colorsNew.card.regular : theme.colorsNew.gray.white};
  border: ${({ selected, theme }) =>
    `1px solid  ${selected ? theme.colorsNew.gray.subtleBorder : theme.colorsNew.gray.grayMedium}`};
  color: ${({ selected, theme }) =>
    selected ? theme.colorsNew.gray.white : theme.colorsNew.gray.blackLight};
  padding: 12px 20px;
  ${({ theme }) => theme.typography.cell}
`;

interface DateTypeSelectorProps {
  byPayDate: boolean;
  onChangeByPayDate: (byPayDate: boolean) => void;
}

const DateTypeSelector = ({ byPayDate, onChangeByPayDate }: DateTypeSelectorProps) => {
  const { t } = useTranslation();

  const onDateTypeSelected = (event: React.MouseEvent<HTMLButtonElement>) =>
    onChangeByPayDate(event.currentTarget.id === 'byPayDate');

  return (
    /*TODO(franco segura): This should be resolved with a radio button */
    <ButtonGroup>
      <CustomButton id="bySaleDate" onClick={onDateTypeSelected} selected={!byPayDate}>
        {t('common:filters:byPayDate:optionFalse')}
      </CustomButton>
      <CustomButton id="byPayDate" onClick={onDateTypeSelected} selected={byPayDate}>
        {t('common:filters:byPayDate:optionTrue')}
      </CustomButton>
    </ButtonGroup>
  );
};

export default DateTypeSelector;
